import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { IActivityType } from '../models';

const baseUrl = '/api/Admin/ActivityType';

export const IActivityTypesAPI = {
  async getAll(): Promise<IActivityType[]> {
    try {
      const response: AxiosResponse<IActivityType[]> = await authFetch.get(baseUrl);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async upsert(upsertData: IActivityType[]): Promise<IActivityType[]> {
    try {
      const response: AxiosResponse<IActivityType[]> = await authFetch.put(baseUrl, upsertData);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
